import React, { useEffect, useRef } from "react";
import styled from "styled-components";
import { Svg } from "./Svg";
import { mdiClose } from "@mdi/js";
import { ScrollBox } from "./ScrollBox";
import { SortableList } from "./SortableList";

const BoxStyle = styled.div`
    position: relative;
    border-radius: 2px;
    border: 1px solid ${props => props.theme.greyLight};
    outline: ${props => (props.$selected ? `2px solid ${props.theme.greenDark}` : "none")};
`;

// the whole box is the drag handle
const Box = ({ dragProps, ...rest }) => <BoxStyle {...dragProps} {...rest} />;

const ContentStyle = styled.div`
    padding: 7px;
`;

const CloseButtonStyle = styled.button`
    right: 0px;
    z-index: 1;
    padding: 0;
    height: 17px;
    border: none;
    cursor: pointer;
    border-radius: 2px;
    position: absolute;
    color: ${props => props.theme.white};
    background: ${props => props.theme.primaryLight};
    &:hover {
        color: ${props => props.theme.primaryLighter};
    }
`;

export const BoxList = props => {

    const { selectedIndex } = props;

    const boxRefs = useRef([]);
    const scrollBoxRef = useRef(null);
    const childrenArray = React.Children.toArray(props.children);

    useEffect(() => {
        if (selectedIndex !== null && selectedIndex !== undefined && boxRefs.current[selectedIndex]) {
            const box = boxRefs.current[selectedIndex];
            const scrollBox = scrollBoxRef.current;

            if (scrollBox && box) {
                // relative to the scroll box, independent of the positioned slot SortableList puts around the box
                const boxTop = box.getBoundingClientRect().top - scrollBox.getBoundingClientRect().top + scrollBox.scrollTop;
                const boxBottom = boxTop + box.offsetHeight;
                const scrollBoxTop = scrollBox.scrollTop;
                const scrollBoxBottom = scrollBoxTop + scrollBox.clientHeight;

                if (boxTop < scrollBoxTop) {
                    scrollBox.scrollTop = boxTop - 80;
                } else if (boxBottom > scrollBoxBottom) {
                    scrollBox.scrollTop = boxBottom - scrollBox.clientHeight + 80;
                }
            }
        }
    }, [selectedIndex]);

    const onSelect = index => {
        if (props.onSelect) {
            props.onSelect(index);
        }
    };

    const onClose = (index, event) => {
        event.stopPropagation();
        if (props.onClose) {
            props.onClose(index);
        }
    };

    return (
        <ScrollBox ref={scrollBoxRef}>
            <SortableList onChangeOrder={props.onChangeOrder}>
                {childrenArray.map((child, index) => (
                    <Box
                        key={index}
                        ref={el => (boxRefs.current[index] = el)}
                        onClick={() => onSelect(index)}
                        $selected={selectedIndex === index}>
                        {props.onClose &&
                            <CloseButtonStyle
                                onClick={event => onClose(index, event)}>
                                <Svg path={mdiClose} size={17} />
                            </CloseButtonStyle>
                        }
                        <ContentStyle>
                            {React.cloneElement(child, {
                                selected: (selectedIndex === index)
                            })}
                        </ContentStyle>
                    </Box>
                ))}
            </SortableList>
        </ScrollBox>
    );
};